/*
 * Hazy Grove — live variant updates for variant-scoped custom metafields.
 *
 * Dawn's product-info.js re-fetches only the main-product section on variant
 * change and swaps a fixed set of sub-elements (price, sku, inventory, …). The
 * custom metafields that moved to variant scope are rendered in two places:
 *
 *   1. Inside the main-product section (subtitle, COA link). Dawn has already
 *      fetched and parsed that section before publishing variantChange, so we
 *      swap those nodes straight from event.data.html — no extra request.
 *
 *   2. In separate JSON-template sections (product info grid, warning banner),
 *      tagged with the `hg-variant-section` class. These are re-rendered via
 *      Shopify's Section Rendering API (?sections=) in a single request.
 *
 * Loaded from sections/main-product.liquid, so it only runs on product pages.
 */
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  // Section Rendering API allows at most 5 sections per request.
  var SECTION_LIMIT = 5;

  // Blocks living inside main-product that depend on the selected variant.
  // Their wrappers are keyed `<Prefix>-<sectionId>` and always present in the
  // DOM (empty when the variant has no value), so the swap target is stable.
  function syncMainProductBlocks(data) {
    if (!data.html) return;
    // HgVariantGallery is a stable outer wrapper; swapping its innerHTML brings
    // in a fresh <hg-variant-gallery> for the new variant, which reconnects and
    // rebinds. See snippets/hg-variant-gallery.liquid.
    ['HgProductTitle', 'HgDescription', 'HgCoaLink', 'HgVariantGallery'].forEach(function (prefix) {
      var id = prefix + '-' + data.sectionId;
      var source = data.html.getElementById(id);
      var destination = document.getElementById(id);
      if (source && destination) destination.innerHTML = source.innerHTML;
    });
  }

  function getHgSectionIds() {
    return Array.prototype.slice
      .call(document.querySelectorAll('.shopify-section.hg-variant-section'))
      .map(function (el) {
        return el.id.replace('shopify-section-', '');
      })
      .filter(Boolean);
  }

  var abortController;

  function refreshHgSections(data) {
    var ids = getHgSectionIds();
    if (!ids.length) return;

    if (ids.length > SECTION_LIMIT) {
      console.warn(
        '[hg-variant-sections] ' +
          ids.length +
          ' variant sections on page; only the first ' +
          SECTION_LIMIT +
          ' will live-update on variant change.'
      );
    }
    var requested = ids.slice(0, SECTION_LIMIT);

    var baseUrl =
      (document.querySelector('product-info') && document.querySelector('product-info').dataset.url) ||
      window.location.pathname;
    var url = baseUrl + '?variant=' + data.variant.id + '&sections=' + requested.join(',');

    if (abortController) abortController.abort();
    abortController = new AbortController();

    fetch(url, { signal: abortController.signal })
      .then(function (response) {
        return response.json();
      })
      .then(function (sections) {
        requested.forEach(function (id) {
          var markup = sections[id];
          if (markup == null) return; // a section can return null — skip it
          var parsed = new DOMParser().parseFromString(markup, 'text/html');
          var incoming = parsed.getElementById('shopify-section-' + id) || parsed.querySelector('.shopify-section');
          var current = document.getElementById('shopify-section-' + id);
          if (!current) return;
          current.innerHTML = incoming ? incoming.innerHTML : parsed.body.innerHTML;
          // Fresh .hg-section markup starts hidden (opacity:0) and is only revealed
          // when the scroll-animation IntersectionObserver adds .hg-animate. That
          // observer was watching the node we just replaced, so reveal the new
          // content directly — otherwise the swapped-in section stays invisible.
          var revealed = current.querySelectorAll('.hg-section');
          revealed.forEach(function (el) {
            el.classList.add('hg-animate');
          });
          // Collapse/show the wrapper explicitly by content. The warning banner is
          // empty on THC-free variants and populated on THC variants. We don't rely
          // on the :has() CSS re-evaluating after an innerHTML swap because that
          // invalidation is unreliable across browsers (e.g. Safari), which would
          // leave the banner stuck hidden when switching back to a THC variant.
          current.style.display = revealed.length ? 'block' : 'none';
        });
      })
      .catch(function (error) {
        if (error.name !== 'AbortError') console.error('[hg-variant-sections]', error);
      });
  }

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var data = event && event.data;
    if (!data || !data.variant) return;
    syncMainProductBlocks(data);
    refreshHgSections(data);
  });
})();
